<template>
<div>

    <div class="box partner-box" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/yamaha2.png" alt="Yamaha Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/partners/yamaha2.png" alt="Yamaha Logo">
          </div>
            <br>
            <p>In partnership with Yamaha Motor Finance Corporation, U.S.A. (“YMFUS”), WebBank is the issuer and
                lender of open-end revolving credit card accounts for consumers for the purchase of Powersports
                products nationwide. If you have any questions about your account, please call 877-327-7310. Or visit
                <a href="#" title="Your account at Yamaha" @click="$emit('link-click', 'https://www.yamaha-motor-finance.com/about-us/#ContactUs')">here</a>.</p>
            <br>
            <p><a href="#" title="Yamaha Cardholder Agreement" @click="$emit('link-click', 'https://yamahamotorfinanceusa.com/docs/CardHolderAgreement.pdf')">Yamaha Cardholder Agreement</a></p>
            <br>
            <p><a href="#" title="Yamaha Privacy Policy" @click="$emit('link-click', 'https://www.yamaha-motor-finance.com/wp-content/uploads/2025/05/ymfus-privacy-policy-legal-3.1.25-v2.pdf')">Yamaha Privacy Policy</a></p>
            <br>
            <p><a href="#" title="Yamaha Privacy Notice" @click="$emit('link-click', 'https://www.yamaha-motor-finance.com/wp-content/uploads/2025/05/ymfus-privacy-notice-04-17-25.pdf')">Yamaha Privacy Notice</a></p>
            <br>
            <p><a href="#" title="WebBank Privacy Notice" @click="$emit('link-click', 'https://www.yamaha-motor-finance.com/wp-content/uploads/2025/05/ymfuswebbankprivacynotice.pdf')">WebBank Privacy Notice</a></p>
            <br>
            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
